// Module
var code = "<div class=\"block\"> <div class=\"date\">{{ auditEvent.timestamp | datetime:null:timezone }}</div> <div> <div>{{ auditEvent.actionType }}</div> <div *ngIf=\"auditEvent['resource']\"> {{ startResource }}<span class=\"font-weight-bold\">{{ endResource }}</span> </div> </div> </div>";
// Exports
module.exports = code;